import { useNavigate } from "react-router-dom";
import { Paths } from "../enums/Paths";

const useNavigationHelper = () => {
    const navigate = useNavigate()

    const navigateToMonthDetail = (nomeProfissional: string, mes: any, agenda: any)=>{
        return navigate(Paths.AgendasMes, { state: { nomeProfissional: nomeProfissional, mesFormatado:`${mes.mesDescricao} de ${mes.ano}`, agenda: agenda }})
    }

    const navigateToHealthProfessionalDetail = (item: any)=>{
        return navigate(Paths.Agendas, { state: { nome: item.nome, agenda: item }})
    }

    const navigateToCreateAgenda = (item: any)=>{
        return navigate(Paths.CriarAgenda, { state: { nomeProfissional: item.nome }})
    }

    const navigateToAgendaDia = (nome: string, data: any, agenda: any)=>{
        return navigate(Paths.AgendaDias, { state: { nomeProfissional: nome, data: data, horaInicio: data.horarioInicio, horaFim: data.horarioFim, agenda: agenda }})
    }

    return { 
        navigateToMonthDetail, 
        navigateToHealthProfessionalDetail, 
        navigateToCreateAgenda, 
        navigateToAgendaDia
    };
}

export default useNavigationHelper;